import styled from "styled-components";

export default styled.div`
    .main .text {
        text-align: center;
    }
`;
